import React from 'react'
import PropTypes from 'prop-types'
import { Fieldset } from 'primereact/fieldset'
import styleMemory from '../../../../../css/generals/Memory.module.css'
import { useTranslation } from 'react-i18next'

export default function Processor ({ processor }) {
  const { t } = useTranslation('hardware')
  return (
    <div style={{ marginTop: '1rem' }}>
        {processor?.length > 0 && processor?.map((item, index) => {
          return (
                <Fieldset key={index + 1} legend={`${t('title6')} ${index + 1}`} toggleable className={ styleMemory.legendHeader }>
                    <p><span className={ styleMemory.bold }>{t('label15')}</span><span>{item?.Name ? item?.Name : t('notAvailable')}</span></p>
                    <p><span className={ styleMemory.bold }>{t('label3')}</span><span>{item?.ProcessorId ? item?.ProcessorId : t('notAvailable')}</span></p>
                    <p><span className={ styleMemory.bold }>{t('label1')}</span><span>{item?.Manufacturer ? item?.Manufacturer : t('notAvailable')}</span></p>
                    <p><span className={ styleMemory.bold }>{t('label11')}</span><span>{item?.Description ? item?.Description : t('notAvailable')}</span></p>
                    <p><span className={ styleMemory.bold }>{t('label13')}</span><span>{item?.MaxClockSpeed ? (parseInt(item?.MaxClockSpeed) / 1000) + ' GHz' : t('notAvailable')}</span></p>
                    <p><span className={ styleMemory.bold }>{t('label12')}</span><span>{item?.Model ? item?.Model : t('notAvailable')}</span></p>
                    <p><span className={ styleMemory.bold }>{t('label20')}</span><span>{item?.NumberOfCores ? item?.NumberOfCores : t('notAvailable')}</span></p>
                    <p><span className={ styleMemory.bold }>{t('label21')}</span><span>{item?.NumberOfLogicalProcessors ? item?.NumberOfLogicalProcessors : t('notAvailable')}</span></p>
                </Fieldset>
          )
        })}
    </div>
  )
}

Processor.propTypes = {
  processor: PropTypes.array
}
